define('model/TermsAndConditionsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Simplybook Terms and Conditions model
     *
     * @class TermsAndConditionsModel
     */
    return BaseModel.extend({

        _lang: 'en',

        url: function() {
            return 'https://simplybook.me/' + this._lang + '/terms/client'
        },

        defaults: {
            license_text: ''
        },

        initialize: function (attributes, options) {
            BaseModel.prototype.initialize.call(this, attributes, options);

            this._lang = options.lang;
        },
        
        fetchLanguage: function(lang) {
            this._lang = lang;
            return this.fetch();
        },

        // we assume main server returns t&c as plain text...
        fetch: function (options) {
            options = _.extend(options || {}, {
                dataType: 'text'
            });
            BaseModel.prototype.fetch.call(this, options);
        },

        convertHrefsToAbsolute: function(text) {
            return text.replace(/href="\/([^"]+)"/g, 'href="https://simplybook.me/$1"');
        },

        addTargetBlankToHrefs: function(text) {
            return text.replace(/href="/g, 'target="_blank" href="');
        },

        //...so we store text response in attribute
        parse: function (response) {
            response = this.addTargetBlankToHrefs(this.convertHrefsToAbsolute(response));

            return { license_text: response };
        },

        toJSON: function () {
            var result = BaseModel.prototype.toJSON.call(this);

            result.lang = this._lang;

            return result;
        }

    });

});
